/**
 * Appliquer un délai à l'éxécution de la fonction callback
 * @param {function} callback
 * @param {number} delay
 * @returns {function}
 */
export const debounce = function (callback, delay) {
    let timer;
    return function test() {
        let args = arguments;
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, delay);
    };
};
